// extracted by mini-css-extract-plugin
export default {"question_right":"QuestionRight_question_right__vJ0Of"};